import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { ModelEntity } from '../../models/model-entity.model';
import { getModelsForBrandSelector } from '../../store/selectors/get-models-for-brand/get-models-for-brand.selector';
import { getModelsByBrand } from '../../thunk/get-models-by-brand.thunk';

export const useGetModelsForBrand = (brandId?: number): ModelEntity[] => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (brandId) {
      dispatch(getModelsByBrand(brandId));
    }
  }, [brandId]);

  return useAppSelector(getModelsForBrandSelector);
};
